import request from '../request'

export function getMainStat(lang, query) {
    return request({
        url: '/api/main_stat',
        method: 'get',
        params: query
    })
}

export function getActiveSchools(query) {
    return request({
        url: '/api/active_schools',
        method: 'get',
        params: query
    })
}
export function getProposedSchools(query) {
    return request({
        url: '/api/proposed_schools',
        method: 'get',
        params: query
    })
}

export function getNews(query) {
    return request({
        url: '/api/news',
        method: 'get',
        params: query
    })
}

export function getNewsId(id) {
    return request({
        url: '/api/news/'+id,
        method: 'get'
    })
}


export function getFaq(query) {
    return request({
        url: '/api/faq',
        method: 'get',
        params: query
    })
}

export function getCity( query) {
    return request({
        url: '/api/city',
        method: 'get',
        params: query
    })
}

export function getRegionCityId(id, query) {
    return request({
        url: '/api/regions/'+id,
        method: 'get',
        params: query
    })
}

export function getCityID( id, query) {
    return request({
        url: '/api/city/'+id,
        method: 'get',
        params: query
    })
}

export function getRegion( query) {
    return request({
        url: '/api/region',
        method: 'get',
        params: query
    })
}

export function getObjectsByCity(id, query) {
    return request({
        url: '/api/'+id+'/objects',
        method: 'get',
        params: query
    })
}

export function getObjectsById( id, query) {
    return request({
        url: '/api/object/' +id,
        method: 'get',
        params: query
    })
}

export function getCategories( query) {
    return request({
        url: '/api/categories',
        method: 'get',
        params: query
    })
}

export function getPrivateSchools( query) {
    return request({
        url: '/api/private',
        method: 'get',
        params: query
    })
}
export function getPrivateSchoolsId(id,  query) {
    return request({
        url: '/api/private/'+id,
        method: 'get',
        params: query
    })
}

export function getRealized(query) {
    return request({
        url: '/api/realized',
        method: 'get',
        params: query
    })
}

export function getRealizedId(id) {
    return request({
        url: '/api/realized/'+id,
        method: 'get'
    })
}

export function postSendMessage(lang, data) {
    return request({
        url: '/api/'+lang+'/sendMail',
        method: 'post',
        data
    })
}
